import React from "react";
import { ActivityIndicator as RNActivityIndicator, } from "react-native";
import { usePaletteColor } from "./hooks/use-palette-color";
const ActivityIndicator = ({ color = "primary", ...rest }) => {
    const { main } = usePaletteColor(color);
    return <RNActivityIndicator {...rest} color={main}/>;
};
export default ActivityIndicator;
